import { type ReactElement } from 'react';
import Head from 'next/head';
import Script from 'next/script';

function MetaSocialTags({
  url,
  socialNetwork,
  title,
  description,
  image,
}: MetaSocialProps): ReactElement {
  switch (socialNetwork) {
    case 'Facebook':
      return (
        <>
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={image} />
          {url && <meta property="og:url" content={url} />}
        </>
      );
    case 'Twitter':
      return (
        <>
          <meta name="twitter:card" content="summary_large_image" />
          <meta name="twitter:title" content={title} />
          <meta name="twitter:description" content={description} />
          <meta name="twitter:image" content={image} />
          {url && <meta name="twitter:url" content={url} />}
        </>
      );
    default:
      return (
        <>
          <meta property="og:title" content={title} />
          <meta property="og:description" content={description} />
          <meta property="og:image" content={image} />
          {url && <meta property="og:url" content={url} />}
        </>
      );
  }
}

export default function SeoTags(data: SeoProps): ReactElement {
  const {
    metaTitle,
    metaDescription,
    // metaImage,
    metaViewport,
    metaRobots,
    metaSocial,
    keywords,
    canonicalURL,
    extraScripts,
    extraStyles,
  } = data;
  return (
    <Head>
      <title>{metaTitle}</title>
      <meta charSet="utf-8" />
      <meta name="viewport" content={metaViewport ?? 'initial-scale=1.0, width=device-width'} />
      <meta name="description" content={metaDescription} />
      <meta property="og:site_name" content="Anychart Qlik Extensions" />
      {metaSocial && metaSocial.map((social) => (
        <MetaSocialTags
          key={social.socialNetwork}
          url={canonicalURL}
          socialNetwork={social.socialNetwork}
          title={social.title}
          description={social.description}
          image={social.image}
        />
      ))}
      {metaRobots && <meta name="robots" content={metaRobots} />}
      {keywords && <meta name="keywords" content={keywords} />}
      {extraScripts && extraScripts.map(({ type, src }) => <Script key={src} src={src} type={type} />)}
      {extraStyles && extraStyles.map((href) => <link key={href} rel="stylesheet" href={href} />)}
    </Head>
  );
}
